var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.688,
    height: 69.688,
    viewBox: "0 0 69.688 69.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-close-circle-outline",
    "data-name": "Icon ionic-md-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30333",
    "data-name": "Path 30333",
    d: "M38.219,10.411a27.8,27.8,0,1,1-19.667,8.141,27.693,27.693,0,0,1,19.667-8.141m0-7.036A34.844,34.844,0,1,0,73.062,38.219,34.838,34.838,0,0,0,38.219,3.375Z",
    fill: "#b00020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30334",
    "data-name": "Path 30334",
    d: "M38.216,34.364l-3.851,3.851L24.452,28.3l-9.913,9.913-3.851-3.851L20.6,24.452l-9.913-9.913,3.851-3.851L24.452,20.6l9.913-9.913,3.851,3.851L28.3,24.452Z",
    transform: "translate(13.767 13.767)",
    fill: "#b00020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCross);
export default __webpack_public_path__ + "static/media/error-cross.3e2a33a1ad459a2795f6349b29118b0a.svg";
export { ForwardRef as ReactComponent };